export const FETCH_USER_CUSTOMER_INFO = 'SERVICE:CUSTOMER:FETCH_USER_CUSTOMER_INFO'
export const FETCH_USER_CUSTOMER_INFO_SUCCESS = 'SERVICE:CUSTOMER:FETCH_USER_CUSTOMER_INFO_SUCCESS'
export const FETCH_USER_CUSTOMER_INFO_FAIL = 'SERVICE:CUSTOMER:FETCH_USER_CUSTOMER_INFO_FAIL'
